/**
 * Formate un montant en FCFA avec séparateurs de milliers
 */
export function formatCurrency(value: number | string): string {
  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(num)) return String(value);

  return (
    new Intl.NumberFormat('fr-FR', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num) + ' FCFA'
  );
}

/**
 * Formate une date ISO en format français lisible
 */
export function formatDate(dateString: string): string {
  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) return dateString;

    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  } catch (error) {
    console.error('[formatDate] Error:', error);
    return dateString;
  }
}

/**
 * Formate une heure (HH:mm ou HH:mm:ss)
 */
export function formatTime(timeString: string): string {
  if (!timeString) return '';

  // Si déjà au format HH:mm, retourner tel quel
  if (/^\d{2}:\d{2}$/.test(timeString)) return timeString;

  // Si format HH:mm:ss, tronquer
  if (/^\d{2}:\d{2}:\d{2}/.test(timeString)) {
    return timeString.substring(0, 5);
  }

  return timeString;
}

/**
 * Détecte si une valeur est une date ISO
 */
export function isDateString(value: any): boolean {
  if (typeof value !== 'string') return false;

  const dateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/;
  return dateRegex.test(value) && !isNaN(Date.parse(value));
}

/**
 * Détecte si une clé correspond à un montant
 */
export function isCurrencyField(key: string): boolean {
  const currencyKeywords = ['amount', 'price', 'cost', 'total', 'montant'];
  return currencyKeywords.some((keyword) => key.toLowerCase().includes(keyword));
}

/**
 * Détecte si une clé correspond à une date
 */
export function isDateField(key: string): boolean {
  const dateKeywords = ['date', 'at', 'time'];
  return dateKeywords.some((keyword) => key.toLowerCase().includes(keyword));
}
